import { render, staticRenderFns } from "./LmProcessNewOrEdit.vue?vue&type=template&id=b776e50e&scoped=true&"
import script from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessNewOrEdit.vue?vue&type=style&index=0&id=b776e50e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b776e50e",
  null
  
)

export default component.exports